<template>
  <v-card id="reserveDialog">
    <div class="dialog-container">
      <div class="ksd-header">
        <h1 class="ksd-header-title">회의 설정</h1>
        <div class="setting-btn-wrap">
          <img
            src="/static/icon-contents/keep_w.svg"
            style="width: 24px; margin-right: 3px; cursor: pointer"
            @click="openBookmarkMeetingDialog()"
          />
          <img
            src="/static/icon-contents/plus-2.svg"
            style="width: 26px; cursor: pointer"
            @click="openAddBookmarkMeetingDialog()"
          />
        </div>
      </div>
      <div class="dialog-body detailTable">
        <table>
          <colgroup>
            <col width="20%" />
            <col width="80%" />
          </colgroup>
          <tbody>
            <tr>
              <th><span>제목</span></th>
              <td>
                <input
                  style="width: 120px"
                  type="text"
                  class="form-control"
                  disabled
                  placeholder="필수 입력"
                  v-model="meeting.title"
                />
              </td>
            </tr>
            <tr>
              <th><span>일시</span></th>
              <td>
                <date-picker
                  :disabled="true"
                  v-model="meeting.startDate"
                  format="YYYY-MM-DD"
                  value-type="format"
                  :lang="lang"
                  style="width: 120px; height: 28px; font-size: 13px"
                ></date-picker>
                <input
                  type="text"
                  v-model="meeting.startTime"
                  :disabled="true"
                  class="form-control mw-120"
                  style="width: 100px; margin: 0 5px"
                />
                <span style="font-size: 11px">~</span>
                <date-picker
                  :disabled="true"
                  v-model="meeting.endDate"
                  format="YYYY-MM-DD"
                  value-type="format"
                  :lang="lang"
                  style="
                    width: 120px;
                    height: 28px;
                    margin-left: 10px;
                    font-size: 13px;
                  "
                ></date-picker>
                <input
                  type="text"
                  v-model="meeting.endTime"
                  :disabled="true"
                  class="form-control mw-120"
                  style="width: 100px; margin: 0 5px"
                />
              </td>
            </tr>
            <tr>
              <th><span>참석자</span></th>
              <td>
                <input
                  class="form-control"
                  type="text"
                  placeholder="선택 사항"
                  @click="openMeetingInvitaionDialog()"
                  :value="meeting.attendeesString"
                  disabled
                />
              </td>
            </tr>
            <tr>
              <th><span>화상회의실</span></th>
              <td>
                <input
                  style="width: 220px;"
                  class="form-control"
                  type="text"
                  :value="meeting.selectedConferenceRoomString"
                  disabled
                />
              </td>
            </tr>
            <tr>
              <th><span>레이아웃</span></th>
              <td>
                <input
                  class="form-control"
                  placeholder="선택사항"
                  style="cursor: pointer"
                  type="text"
                  @click="openMeetingLayoutDialog()"
                  v-bind:style="{
                    display: meeting.layout.isLayout ? 'none' : '',
                  }"
                  readonly
                />
                <img
                  style="width: 80px"
                  :src="`${meeting.layout.selectedLayoutImage}`"
                  v-bind:style="{
                    display: meeting.layout.isLayout ? '' : 'none',
                  }"
                  @click="openMeetingLayoutDialog()"
                />
              </td>
            </tr>
            <tr>
              <th><span>부가기능</span></th>
              <td>
                <div class="input-checkbox">
                  <label
                    ><input
                      type="checkbox"
                      class="form-control"
                      name="a"
                      v-model="meeting.meetingLog"
                      :disabled="meeting.meetingLogEn || meeting.conferenceRoomActive || meeting.exMeeting"
                    /><span>스마트회의록</span></label
                  >
                  <label
                    ><input
                      type="checkbox"
                      class="form-control"
                      name="a"
                      v-model="meeting.meetingLogEn"
                      :disabled="meeting.meetingLog || meeting.conferenceRoomActive || meeting.exMeeting"
                    /><span>스마트회의록(영문)</span></label
                  >
                  <label
                    ><input
                      type="checkbox"
                      class="form-control"
                      name="a"
                      v-model="meeting.allPublicMeeting"
                    /><span>전체 공개회의</span></label
                  >
                  
                  <label
                    ><input
                      type="checkbox"
                      class="form-control"
                      name="a"
                      v-model="meeting.exMeeting"
                      :disabled="meeting.conferenceRoomActive"
                    /><span>스마트 단말기 전용</span></label
                  >
                  <label style="margin-right: 5px"
                    ><input
                      type="checkbox"
                      class="form-control"
                      name="a"
                      v-model="meeting.isPrivate"
                      :disabled="meeting.allPublicMeeting"
                    /><span>비밀번호</span></label
                  >
                  <input
                    :style="{ display: isPrivate }"
                    type="password"
                    placeholder="비밀번호를 입력하세요"
                    class="form-control"
                    style="width:126px; margin-left: 5px; padding-left: 0;"
                    v-model="meeting.meetingPW"
                  />
                </div>
              </td>
            </tr>
          </tbody>
        </table>

        <div style="height: 50px"></div>
        <div class="dialog-footer">
          <button class="btnPrimary" @click="createMeeting">완료</button>
          <button class="noIconButton" @click="close">취소</button>
        </div>
      </div>
    </div>

    <meeting-layout-dialog
      :dialog="meetingLayoutDialog.dialog"
      :attendees="meetingLayoutDialog.attendees"
      :meeetingFixSeatList="meetingLayoutDialog.fixSeatList"
      :selectLayoutCode="meetingLayoutDialog.selectedLayoutCode"
      :conferenceRoomActive="meeting.conferenceRoomActive"
      @selectedFixSeatList="selectedFixSeatList"
      @closeMeetingLayoutDialog="closeMeetingLayoutDialog"
    />

    <!-- 회의 불러오기 보기 -->
    <bookmark-meeting-dialog
      :dialog="bookmarkMeetingDialog.dialog"
      @selectedBookmarkMeeting="selectedBookmarkMeeting"
      :closeDialog="closeBookmarkMeetingDialog"
    />

    <!-- 회의 저장 -->
    <add-bookmark-meeting-dialog
      :dialog="addBookmarkMeetingDialog.dialog"
      :meetingInfo="addBookmarkMeetingDialog.meetingInfo"
      :closeDialog="closeAddBookmarkMeetingDialog"
    />
    <alert :dialog="alertDialog.dialog" :contents="alertDialog.contents" :closeDialog="closeAlert"></alert>
  </v-card>
</template>
<script>
import Util from '@/util';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import MeetingCreate from '@/components/meeting/MeetingCreate';
/* import MeetingTypeDialog from '@/components/popup/MeetingTypeDialog'; */
import moment from 'moment';
import timezone from 'moment-timezone';

import MeetingLayoutDialog from '@/components/popup/MeetingLayoutDialog';
import BookmarkMeetingDialog from '@/components/popup/BookmarkMeetingDialog';
import AddBookmarkMeetingDialog from '@/components/popup/AddBookmarkMeetingDialog';
import Alert from '@/components/popup/Alert.vue';
export default {
  filters: {
    conferenceDayFilter(day) {
      if (day === null) {
        return moment().format('YYYY / MM / DD');
      } else {
        return moment(day).format('YYYY / MM / DD');
      }
    },
    conferenceTimeFilter(time) {
      return moment(time).format('HH시 mm분');
    },
    textLengthOverCut(txt, len, lastTxt) {
      if (len === '' || len === null) {
        len = 5;
      }
      if (lastTxt === '' || lastTxt === null) {
        lastTxt = '...';
      }
      console.log(txt.length);
      console.log(len);
      if (txt.length > len) {
        txt = txt.substr(0, len) + lastTxt;
        console.log(txt);
      }
      return txt;
    },
  },
  components: {
    MeetingCreate,
    /* MeetingTypeDialog, */
    BookmarkMeetingDialog,
    AddBookmarkMeetingDialog,
    MeetingLayoutDialog,
    DatePicker,
    Alert
  },
  data() {
    return {
      isDisabled: false,
      alertDialog: {
        dialog: false,
        contents: '',
      },
      allPublicMeeting: false,
      lang: {
        days: ['일', '월', '화', '수', '목', '금', '토'],
        months: [
          '1월',
          '2월',
          '3월',
          '4월',
          '5월',
          '6월',
          '7월',
          '8월',
          '9월',
          '10월',
          '11월',
          '12월',
        ],
        yearFormat: 'YYYY년',
        monthFormat: 'MM월',
        // the calendar title of month before year
        monthBeforeYear: false,
      },
      pickrFormat: 'YYYY.MM.DD',
      userKey: null,
      immediatlyDialog: false,
      immediatlyMeetingInfo: null,
      immediatlyRoomOption: null,
      isTimeFixed: false,
      max: 4,
      isHelpActive: 'none',
      addSchedule: null,
      startTime: null,
      endTime: null,
      loading: true,
      attendeesString: null,
      selectedConferenceRoomString: null,
      meetingBookmarkImage: '/static/seoul/img/bookmark_off.png',
      meetingBookmarkActive: false,
      meetingLogActive: false,
      meetingTypeDialog: {
        dialog: false,
        attendees: [],
      },
      bookmarkMeetingDialog: {
        dialog: false,
      },
      addBookmarkMeetingDialog: {
        dialog: false,
        meetingInfo: {},
      },
      meetingConferenceDialog: {
        dialog: false,
        conferenceRooms: [],
      },
      meetingLayoutDialog: {
        dialog: false,
        attendees: [],
        fixSeatList: [],
        selectedLayoutCode: null,
      },
      meetingInvitaionDialog: {
        dialog: false,
        attendees: [],
        notice: {
          email: true,
          kakao: false,
        },
      },
      conferenceAgreeDialog: {
        dialog: false,
      },
      guideLogDialog: {
        dialog: false,
      },
      recLogDialog: {
        dialog: false,
      },
      addBookmarkMeetingBtn: false,
      isPrivate: 'none',
      meetingType: 'general',
      conferenceRoomActive: false,
      meetingPublicType: 'public',
      isActive: 'none',
      isRoomActive: 'none',
      isActiveStartTime: 'none',
      isInputLayout: '',
      isLayout: 'none',
      guideLog: null,
      recLog: null,
      meetingLog: null,
      meetingBanner: false,
      calendarLink: false,
      meeting: {
        creator: {
          email: null,
        },
        title: null,
        immediateMeeting: false,
        startDate: new Date().toISOString().substr(0, 10),
        startTime: null,
        endTime: null,
        startDtime: null,
        endDtime: null,
        attendees: [],
        conferenceRoomActive: false,
        selectedConferenceRoomString: null,
        selectedConferenceRoomArr: [],
        meetingLog: false,
        meetingLogEn: false,
        allPublicMeeting: false,
        meetingPublicType: false,
        password: null,
        roomOption: null,
        exMeeting: false,
        roomIds: [],
        layout: {
          isLayout: false,
          selectedLayoutCode: '',
          selectedLayoutImage: '',
          fixSeatList: [],
        },
        resultFixSeat: [],
        meetingPW: null,
        isPrivate: false,
        rec: false,
      },

      error: null,
      immediateMeeting: true,
      selectedConferenceRoom: null,
      selectedConferenceRoomArr: [],
      guideLogContents: null,
      recLogContents: null,
    };
  },
  watch: {
    'meeting.isPrivate' () {
      if (this.meeting.isPrivate === true) {
        this.isPrivate = '';
      } else {
        this.isPrivate = 'none';
        this.meeting.meetingPW = '';
      }
    },
    'meeting.allPublicMeeting' () {
      if (this.meeting.allPublicMeeting === true) {
        this.isPrivate = 'none';
        this.meeting.meetingPW = '';
        this.meeting.isPrivate = false;
      }
    },
  },
  mounted() {
    this.initMeeting();
  },
  methods: {
    async initMeeting() {
      let meetingKey = Util.getParam('meetingKey');
      let params = {
        meetingKey: meetingKey,
      };

      await this.$http
        .get('/api/v1/meetings/ksd/getMeeting', { params: params })
        .then((response) => {
          let data = response.data[0];
          if (data.status === 'e') {
            alert('종료된 회의입니다.');
            window.close();
            return;
          } else if (data.status === 's') {
            alert('시작한 회의입니다.');
            window.close();
            return;
          }
          this.meeting = Object.assign({}, response.data[0]);
          // this.meeting = JSON.parse(JSON.stringify(response.data[0]));
          // 일시
          this.meeting.startDate = moment(this.meeting.startDtime).format(
            'YYYY-MM-DD'
          );
          this.meeting.endDate = moment(this.meeting.endDtime).format(
            'YYYY-MM-DD'
          );

          this.meeting.startTime = moment(this.meeting.startDtime).format(
            'HH:mm'
          );
          this.meeting.endTime = moment(this.meeting.endDtime).format('HH:mm');

          // 참석자
          if (this.meeting.attendees.length === 1) {
            this.meeting.attendeesString = `${this.meeting.attendees[0].name}`;
          } else if (this.meeting.attendees.length > 1) {
            this.meeting.attendeesString = this.$t(
              'page.meeting-reserve.attendee-list-string',
              {
                name: this.meeting.attendees[0].name,
                count: this.meeting.attendees.length - 1,
              }
            );
          } else if (this.meeting.attendees.length === 0) {
            this.meeting.attendeesString = '';
          }
          // 화상회의실
          if (this.meeting.conferenceRooms.length > 1) {
            this.meeting.selectedConferenceRoomString = `${
              this.meeting.conferenceRooms[0].deviceName
            } 외 ${this.meeting.conferenceRooms.length - 1}개`;
          } else {
            this.meeting.selectedConferenceRoomString = this.meeting
              .conferenceRooms
              ? this.meeting.conferenceRooms[0].deviceName
              : '';
          }

          // 고화질 영상회의 자동처리
          if (this.meeting.attendees.length === 0) {
            // 참석자가 0명일 경우 고화질 영상회의
            this.meeting.conferenceRoomActive = true;
          } else {
            if (this.meeting.conferenceRooms.length >= 4) {
              // 참석자가 있는데 영상회의실이 4개 이상일 경우 고화질
              this.meeting.conferenceRoomActive = true;
            }
          }
        });
    },
    close() {
      window.close();
    },
    selectedBookmarkMeeting(meeting) {
      console.log(`bookmarkMeeting : `, meeting);

      /* 레이아웃 */
      if (meeting.layoutCode === null || meeting.layoutCode === undefined) {
        this.isLayout = 'none';
        this.isInputLayout = '';
      } else {
        this.isLayout = '';
        this.isInputLayout = 'none';

        this.meeting.layout.isLayout = true;
        this.meeting.layout.selectedLayoutImage = meeting.layoutImage;
        this.meeting.layout.selectedLayoutCode = meeting.layoutCode;
      }

      this.meeting.rec = meeting.isRecord;
      /* 회의록 */
      this.meeting.meetingLog = meeting.meetingLog;

      /* 전체 공개회의 */
      this.meeting.allPublicMeeting = meeting.allPublicMeeting;

      /* 공개 비공개 */
      if (meeting.meetingPW === null || meeting.meetingPW === '') {
        this.meeting.isPrivate = false;
        this.meeting.meetingPublicType = false;
        this.isPrivate = 'none';
        this.meeting.meetingPW = '';
      } else {
        this.isPrivate = '';
        this.meeting.isPrivate = true;
        this.meeting.meetingPublicType = true;
        this.meeting.meetingPW = meeting.meetingPW;
      }
    },
    closeAddBookmarkMeetingDialog() {
      this.addBookmarkMeetingDialog.dialog = false;
    },
    openBookmarkMeetingDialog() {
      this.bookmarkMeetingDialog.dialog = true;
    },
    closeBookmarkMeetingDialog() {
      this.bookmarkMeetingDialog.dialog = false;
    },
    openAddBookmarkMeetingDialog() {
      let meetingInfo = {
        userKey: this.$store.state.user.empNum,
        layout: this.meeting.layout,
        meetingLog: this.meeting.meetingLog,
        isRecord: this.meeting.rec,
        allPublicMeeting: this.meeting.allPublicMeeting,
        isPrivate: this.meeting.isPrivate,
        meetingPW: this.meeting.meetingPW,
      };

      console.log(`meetingInfo : `, meetingInfo);
      this.addBookmarkMeetingDialog.dialog = true;
      this.addBookmarkMeetingDialog.meetingInfo = meetingInfo;
    },
    // 여기까지 작업
    createMeeting() {
      let userKey = Util.getParam('userKey');
      let meetingKey = Util.getParam('meetingKey');
      let isFixed = false;

      if (this.meeting.layout.selectedLayoutCode !== '') {
        this.meeting.layout.isLayout = true;
        if (
          this.meeting.layout.fixSeatList &&
          this.meeting.layout.fixSeatList.length > 0
        ) {
          isFixed = true;
        }

        if (this.meeting.conferenceRoomActive !== true) {
          // 일반회의 영상회의
          this.meeting.roomOption = Util.getSaehaLayoutOption(
            this.meeting.layout.selectedLayoutCode,
            isFixed,
            this.meeting.layout.fixSeatList
          );
        }
      }

      if (this.meeting.isPrivate) {
        if (this.meeting.meetingPW === null || this.meeting.meetingPW === '') {
          alert('비밀번호를 입력하세요.');
          return;
        }
      }

      let meetingInfo = {
        creator: this.$store.state.user.empNum,
        meetingKey: meetingKey,
        title: this.meeting.title,
        layout: this.meeting.layout,
        roomOption: this.meeting.roomOption,
        conferenceRooms: this.meeting.conferenceRooms,
        conferenceRoomActive: this.meeting.conferenceRoomActive,
        meetingLog: this.meeting.meetingLog,
        meetingLogEn: this.meeting.meetingLogEn,
        allPublicMeeting: this.meeting.allPublicMeeting,
        isPrivate: this.meeting.isPrivate,
        meetingPW: this.meeting.meetingPW,
        exMeeting: this.meeting.exMeeting
      };

      this.$http
        .post('/api/v1/meetings/ksd/settingMeeting', meetingInfo)
        .then((response) => {
          let ret = response.data;

          if (ret) {
            this.alertDialog.dialog = true;
            this.alertDialog.contents = '회의 설정이 완료되었습니다.'; 
          }
        })
        .catch((error) => {
          console.log(error);
          this.error = error.response.data.error;
        });
    },
    deleteConferenceRoom(index) {
      this.selectedConferenceRoomArr.splice(index, 1);
    },
    changeMeetingPublicType() {
      if (this.meetingPublicType === 'public') {
        this.isPrivate = 'none';
        this.meeting.password = null;
      } else {
        this.isPrivate = '';
      }
    },
    changeMeetingType() {
      if (this.meetingType === 'general') {
        this.meetingType = 'general';
        this.attendeesString = this.$t('page.meeting-reserve.attendee-list');
      } else {
        this.meetingType = 'article';
        this.attendeesString = this.$t(
          'page.meeting-reserve.attendee-list-type2'
        );
      }
    },

    closeDialog() {
      this.immediatlyDialog = false;
      window.close();
    },
    openMeetingLayoutDialog() {
      /* 레이아웃 설정 */
      // 참석자 목록 설정
      this.meetingLayoutDialog.attendees = Object.assign(
        [],
        this.meeting.attendees
      );
      if (
        this.meeting.conferenceRoomActive === true &&
        this.meeting.conferenceRooms.length >= 1
      ) {
        // 영상회의실 추가
        let codecList = this.meeting.conferenceRooms.map((c) => {
          c['isDevice'] = true;
          c['name'] = c.deviceName;
          return c;
        });
        this.meetingLayoutDialog.attendees =
          this.meetingLayoutDialog.attendees.concat(codecList);
      }
      // 기존 설정 된 값 Setting
      if (this.meeting.layout && this.meeting.layout.isLayout === true) {
        this.meetingLayoutDialog.fixSeatList = this.meeting.layout.fixSeatList;
        this.meetingLayoutDialog.selectedLayoutCode =
          this.meeting.layout.selectedLayoutCode;
      }
      this.meetingLayoutDialog.dialog = true;
    },
    closeMeetingLayoutDialog() {
      this.meetingLayoutDialog.dialog = false;
    },
    selectedFixSeatList(selectedLayoutCode, selectedLayoutImage, fixSeatList) {
      let fixSeatCount = 0;

      for (let k = 0; k < fixSeatList.length; k++) {
        if (fixSeatList[k].seat !== null) {
          console.log(fixSeatList[k].seat);
          fixSeatCount++;
        }
      }

      this.meeting.layout.isLayout = true;
      this.isInputLayout = 'none';
      this.meeting.layout.selectedLayoutCode = selectedLayoutCode;
      this.meeting.layout.selectedLayoutImage = selectedLayoutImage;

      if (fixSeatCount > 0) {
        this.meeting.layout.fixSeatList = fixSeatList;
      }

      if (this.meeting.layout.selectedLayoutCode === null) {
        this.isInputLayout = '';
        this.meeting.layout.isLayout = false;
      }

      this.closeMeetingLayoutDialog();
    },
    closeAlert () {
      this.closeDialog.dialog = false;
      window.close(); 
    }
  },
};
</script>
<style scoped lang="stylus">
.pop_top{
  font-weight: 600;
}
.input_meeting{
  border:1px solid #d4d4d4;
  width: 100%;
  vertical-align: middle;
  height: 46px;
  display: inline-block;
  line-height: 2em;
  box-sizing: border-box;
  color: #4e4e4e;
  overflow: hidden;
  text-decoration: none;
  text-indent: 10px;
  border-radius:5px;
}

.datetime-start{
  width: 60%;
  height: 50px;
  border: solid 1px #d4d4d4;
  padding-left: 10px;
  line-height: 50px;
  border-radius: 5px;
  float: left;
}
.datetime-end{
  width: 39%;
  margin-left: 1%;
  height: 50px;
  border: solid 1px #d4d4d4;
  padding-left: 10px;
  line-height: 50px;
  border-radius: 5px;
  float: left;
}

.formbox-time-select{
  width: 120px
  height: 45px;
  font-size: 15px;
  font-weight: 300;
  border: 2px solid #dddddd;
  border-radius: 5px;
  padding-left: 20px;
  margin-left: 5px !important;
  line-height: 40px;
  background-image: url(/static/webex-cloud/images/common/selar.png);
  background-position: 87% 52%;
  background-repeat: no-repeat, no-repeat;

  /* background: url(/static/webex-cloud/images/common/selar.png) no-repeat 87% 52%;
  background: url(/static/webex-cloud/images/common/selar.png) no-repeat 25% 52%; */
}

.formbox-banner-select{
  width: 65px;
  height: 30px;
  font-size: 12px;
  font-weight: 100;
  border: 2px solid #dadada;
  border-radius: 5px;
  padding-left: 7px;
  margin-left: 0px !important;
  line-height: 25px;
  background-image: url(/static/webex-cloud/images/common/selar.png);
  background-position: 87% 52%;
  background-repeat: no-repeat;
}


.select-items {
  position: absolute;
  background-color: DodgerBlue;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 99;
}

.meeting-time{
  border: 1px solid #d4d4d4;
  width : 49%;
  height: 46px;
  float: left;
  text-align: center;
  line-height: 46px;
}

.tbw_p01 .active {
  display: '';
}

.tbw_p01 .noActive {
  display: none;
}

.conferenceroom-btn {
  width: max-content;
  padding-right: 10px;
  height: 30px;
  line-height: 30px;
  margin-top: 5px;
  margin-left: 10px;
  background: #fa4242;
  color: white;
  border-radius: 5px;
  z-index: 5;
  position: relative;
  float: left;
}

.conferenceroom-btn p{
  float: left;
  padding-left: 10px;
}
.conferenceroom-btn img{
  float: left;
  cursor: pointer;
  padding-top: 7px;
  padding-left: 3px;
  width: 8px;
}
.pop_tit{
  height: 20px;
  padding: 30px 0 10px;
  color: #444;
  text-align: left;
  letter-spacing: -1px;
  font-size: 25px;
  text-align: center;
  font-weight: 500;
  line-height: 20px;
  width: 100%;
}
.pop_close{
  position: absolute;
  top: 20px;
  right: 20px;
  display:inline-block;
  width:15px;
  height:15px;
  text-indent: -9999px;
  background: url(/static/webex-cloud/images/common/close_btn.png) center center no-repeat;
}

.popContainer {
  background: #fff;
  font-size: 16px;
  height: 520px;
}

.v-picker{
  position: absolute;
  z-index: 1000;
  top: 10px;
  right: 120px;
}

.fix-layout-img {
  position: relative;
  width: 70px;
  left: -80px;
  top: 3px;
  cursor:pointer;
}

#bookmarkMeeting{
  text-align: center;
  font-size: 11.5pt;
  height: 40px;
  line-height: 40px;
  font-weight: 700;
  float: right;
  background: #cbe9f8;
  color: #2f66aa;
  border-radius: 5px;
}

#bookmarkAddMeeting{
  width: 130px;
  text-align: center;
  padding: 0;
  font-size: 10pt;
  height: 40px;
  line-height: 40px;
  font-weight: 100;
  position: relative;
  top: -43px;
  left: 175px;
}

.help-bg{
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: black;
  opacity: 0.98;
  z-index: 999;
  overflow: auto;
  text-align: center;
}
.help-img{
  width: 100%;
  max-width: 720px;
  display: inline-block;
  position: relative;
  top: 7%;
}
.close-img{
  position: fixed;
  top: 8%;
  right: 10%;
  cursor: pointer;
  z-index: 1001;
}
input::placeholder{
  color: #bfc3c5;
  padding-left: 5px;
}

:-ms-input-placeholder { /* Internet Explorer 10-11 */
    color: #bfc3c5 !important;
    font-size: 1rem !important;
}
.dialog-container {
  width: 100%;
}
#reserveDialog .styled-checkbox:checked + label:after{
  left: -87px;
}

.dialog-row {
  justify-content: start;
}

.v-card {
  height: 100%;
}

.v-picker {
  height: auto;
}

input {
  border-radius: 4px;
}

input:disabled {
  padding-left: 5px;
  background-color: #f0f0f0;
  color: #ccc;
}

.mw-120 {
  min-width: 120px;
}
.ksd-header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/ReserveDialog.vue